<div class="splash-screen">
  <div class="agent">
    <svg-icon icon="agent-head"></svg-icon>
  </div>

  <div class="dotted"></div>

  <div class="refresh">
    <svg-icon icon="refresh"></svg-icon>
  </div>

  <div class="dotted"></div>

  <div class="assisted-browsing-icon">
    <svg-icon icon="assisted-browsing-inactive"></svg-icon>
  </div>

  <div class="instructions">
    <div>{{ 'bcAssistedBrowsingPanel.connecting' | translate }}</div>
    <div class="footnote">{{ 'bcAssistedBrowsingPanel.receivingWebPageTakingTooLong' | translate }}</div>
  </div>
</div>
